export default "__VITE_ASSET__DHbgaYvN__"